import React from 'react';
import ReactDOM from 'react-dom';
import LeadForm from '@/Module/LeadCaptureForm/LeadForm';

const domContainer = document.querySelector('#leadform');
ReactDOM.render(<LeadForm />, domContainer);
